import TextField, { OutlinedTextFieldProps } from "@mui/material/TextField";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { Field, getIn } from "formik";
import { kebabCase } from "lodash";

const useStyles = makeStyles(() =>
  createStyles({
    input: {
      maxWidth: "100%",
      width: ({ fullWidth }: { fullWidth?: boolean }) =>
        fullWidth ? "100%" : 373,
    },
  }),
);
type MultiTextInputProps = Omit<OutlinedTextFieldProps, "variant">;
export function MultiTextInput(
  props: MultiTextInputProps & { "data-test-id"?: string },
) {
  const classes = useStyles(props);
  const { "data-test-id": dataTestId } = props;

  return (
    <Field name={props.name}>
      {({ field, form, meta }: { field: any; form: any; meta: any }) => (
        <TextField
          {...field}
          {...props}
          className={`${classes.input} ${props.className}`}
          error={
            !!(meta.error || props.error || getIn(form.status, field.name))
          }
          helperText={
            meta.error || getIn(form.status, field.name) || props.helperText
          }
          onChange={(e) => {
            props.onChange?.(e);
          }}
          value={field.value ?? ""}
          variant="outlined"
          inputProps={{
            autoComplete: "off",
            ...props.inputProps,
            "data-test-id": dataTestId
              ? `${dataTestId}-${kebabCase(field.name)}`
              : `multi-text-input-${kebabCase(field.name)}`,
          }}
        />
      )}
    </Field>
  );
}
